// extracted by mini-css-extract-plugin
export var icon = "Collapsible-module--icon--c8801";
export var open = "Collapsible-module--open--18742";
export var title = "Collapsible-module--title--35cea";